
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250 250"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M184.46 66.38s2.31-30.86-20.88-30.86","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"10"}}),_c('rect',{attrs:{"x":"138.63","y":"27.64","width":"24.95","height":"15.75","rx":"7.88","transform":"rotate(-180 151.105 35.515)","stroke-width":"10","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","fill":"none"}}),_c('path',{attrs:{"fill":"currentColor","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"10","d":"M184.82 119.42H65.18l-17.7-53.04h155.04l-17.7 53.04zM184.69 222.36H65.32l7.43-29.1h28.38v16.88h47.75v-16.88h28.37l7.44 29.1z"}}),_c('path',{attrs:{"stroke-width":"10","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","fill":"none","d":"M101.13 119.43h47.75v90.71h-47.75z"}})])
          )
        }
      }
    